module.exports = __webpack_public_path__ + "img/caas3m.8308ba33.webp";